import { render, staticRenderFns } from "./PaymentsView.vue?vue&type=template&id=ca28c3f0&"
import script from "./PaymentsView.vue?vue&type=script&lang=js&"
export * from "./PaymentsView.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports